import { Controller } from "@hotwired/stimulus"
import {
  SignInWithApple,
} from '@capacitor-community/apple-sign-in';

// Connects to data-controller="apple"
export default class extends Controller {
  connect() {
  }

  signIn() {
    let options = {
      clientId: 'com.fabler.test',
      redirectURI: '/',
      scopes: 'email',
      state: 'initial',
      nonce: 'nonce',
    };

    SignInWithApple.authorize(options)
      .then((result) => {
        fetch('/sign_in', {
          method: "POST",
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(result['response']),
        }).then(async r => {
          let response = await r.json();

          if (response['success'] === true) {
            Turbo.visit('/onboarding');
          }
        })
         // Handle user information
        // Validate token with server and create new session
      })
      .catch(error => {
        // Handle error
      });
  }
}
